import { TextField, type TextFieldProps } from '@mui/material';
import { _ } from '/@/locale';
import { validateEmailV2 } from '/@/utils';
import { getGrowerIdentifierCopy } from './grower-identifier';

/**
 * Validates grower email identifier format and, when provided, that it doesn't match
 * the current user's own node email.
 * Returns an error message or null if valid.
 */
export function validateGrowerIdentifierEmail(email: string, ownEmail?: string): string | null {
    const copy = getGrowerIdentifierCopy('email');
    const trimmed = email.trim();
    if (!trimmed) {
        return _('Ingresá el correo del productor');
    }
    if (!validateEmailV2(trimmed)) {
        return copy.invalidFormat;
    }
    if (ownEmail && trimmed.toLowerCase() === ownEmail.trim().toLowerCase()) {
        return _('El email del productor no puede ser el mismo que el de tu usuario');
    }
    return null;
}

export type EmailIdentifierTextFieldProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
    value: string;
    onChange: (email: string) => void;
};

const EmailIdentifierTextField = ({
    value,
    onChange,
    error,
    helperText,
    InputProps,
    ...textFieldProps
}: EmailIdentifierTextFieldProps) => {
    const copy = getGrowerIdentifierCopy('email');

    return (
        <TextField
            label={copy.fieldLabel}
            fullWidth
            size='small'
            type='email'
            placeholder='productor@mail.com'
            value={value}
            onChange={(e) => onChange(e.target.value)}
            error={error}
            helperText={helperText != null ? helperText : copy.fieldHelp}
            InputProps={InputProps}
            {...textFieldProps}
        />
    );
};

export default EmailIdentifierTextField;
